import { defineStore } from 'pinia';
import { isObject, isArray } from '/@/utils/is';

interface GlobalWebsocketMessageInterface {
  globalWebsocketMessage?: Object;
  partitionIds: Array<number>;
}
export const useEventInfoStore = defineStore({
  id: 'app-event-info',
  state: (): GlobalWebsocketMessageInterface => ({
    globalWebsocketMessage: {},
    partitionIds: [],
  }),
  getters: {
    getEventInfo(): any {
      return this.globalWebsocketMessage;
    },
    getPartitionIds(): Array<number> {
      return this.partitionIds;
    },
  },
  actions: {
    setEventInfo(info: object) {
      this.globalWebsocketMessage = isObject(info) ? info : {};
    },
    setPartitionIds(info: Array<number>) {
      this.partitionIds = isArray(info) ? info : [];
    },
    resetState() {
      this.globalWebsocketMessage = {};
      this.partitionIds = [];
    },
  },
  persist: {
    pick: ['partitionIds'],
    storage: localStorage,
  },
});
